export const ROUTES = {
  HOME: '/',
  INTRODUCTION: '/introduction',
  SIGNUP: '/signup',
  LOGIN: '/login',
  PROFILE: '/profile',
  DASHBOARD: '/introduction',
  JOBS: '/profile/jobs',
  PROJECTS: '/projects',
  SAMPLES: '/jobs/:projectId/samples',

  // Reports
  REPORTS: '/reports/:jobId',

  // Pipelines
  RNA_SEQ: '/pipelines/rna-seq',
  SCRNA_SEQ: '/pipelines/scrna-seq',
  CHIP_SEQ: '/pipelines/chip-seq',
  HLA_GENOTYPE: '/pipelines/hla-genotype-caller',
  GENOME_ALIGNMENT: '/pipelines/genome-alignment',
  SOMATIC_MUTATION: '/pipelines/somatic-mutation',
  GERMLINE_MUTATION: '/pipelines/germline-mutation',
  WGS_WES_REPORT: '/pipelines/wgs-wes-report',
  PGX_DRUG_REPORT: '/pipelines/pgx-drug-report',
} as const;
